import { Api } from './Api';

const getSalesReport = async ({ dataInicio, dataFim, categoriaId } = {}) => {
    try {
        const params = new URLSearchParams();

        if (dataInicio) params.append('dataInicio', dataInicio);
        if (dataFim) params.append('dataFim', dataFim);
        if (categoriaId) params.append('categoriaId', categoriaId);

        const url = `/api/magento/relatorios/vendas${params.toString() ? `?${params}` : ''}`;
        const { data } = await Api.get(url);

        if (data) {
            return data;
        }

        return new Error('Erro ao carregar o relatório.');
    } catch (error) {
        return new Error(error.message || 'Erro ao carregar o relatório.');
    }
};

const getOperationReport = async ({ dataInicio, dataFim, categoriaId } = {}) => {
    try {
        const params = new URLSearchParams();

        if (dataInicio) params.append('dataInicio', dataInicio);
        if (dataFim) params.append('dataFim', dataFim);
        if (categoriaId) params.append('categoriaId', categoriaId);

        const url = `/api/magento/relatorios/operacao${params.toString() ? `?${params}` : ''}`;
        const { data } = await Api.get(url);

        if (data) {
            return data;
        }

        return new Error('Erro ao carregar o relatório.');
    } catch (error) {
        return new Error(error.message || 'Erro ao carregar o relatório.');
    }
};

export const MagentoService = {
    getSalesReport,
    getOperationReport
};
